import { useEffect } from 'react';
import { useSiteData } from '../../context/SiteDataContext';

const SeoManager = () => {
  const { settings } = useSiteData();

  const isPlaceholder = (id) => !id || /^G-?X+$/i.test(id) || /^\d+$/.test(id);

  useEffect(() => {
    // 1. Dynamic Title
    const defaultTitle = 'MEDTREND — Surgical Instruments Manufacturer & Exporter';
    document.title = settings.seo_title || defaultTitle;

    // 2. Dynamic Description
    const defaultDesc = 'Premium ISO 13485 & CE certified surgical instruments drop-forged from premium steel.';
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) {
      metaDesc.setAttribute('content', settings.seo_description || defaultDesc);
    }

    // 3. Google Analytics Integration
    if (settings.google_analytics_id && !isPlaceholder(settings.google_analytics_id)) {
      const gaId = settings.google_analytics_id;
      // Check if script already exists
      if (!document.getElementById('google-analytics-script')) {
        const script1 = document.createElement('script');
        script1.async = true;
        script1.src = `https://www.googletagmanager.com/gtag/js?id=${gaId}`;
        script1.id = 'google-analytics-script';
        document.head.appendChild(script1);

        const script2 = document.createElement('script');
        script2.id = 'google-analytics-init';
        script2.innerHTML = `
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', '${gaId}');
        `;
        document.head.appendChild(script2);
      }
    }

    // 4. Facebook Pixel Integration
    if (settings.facebook_pixel_id && !isPlaceholder(settings.facebook_pixel_id)) {
      const pixelId = settings.facebook_pixel_id;
      if (!document.getElementById('facebook-pixel-script')) {
        const script = document.createElement('script');
        script.id = 'facebook-pixel-script';
        script.innerHTML = `
          !function(f,b,e,v,n,t,s)
          {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
          n.callMethod.apply(n,arguments):n.queue.push(arguments)};
          if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
          n.queue=[];t=b.createElement(e);t.async=!0;
          t.src=v;s=b.getElementsByTagName(e)[0];
          s.parentNode.insertBefore(t,s)}(window, document,'script',
          'https://connect.facebook.net/en_US/fbevents.js');
          fbq('init', '${pixelId}');
          fbq('track', 'PageView');
        `;
        document.head.appendChild(script);

        const noscript = document.createElement('noscript');
        noscript.id = 'facebook-pixel-noscript';
        noscript.innerHTML = `
          <img height="1" width="1" style="display:none"
          src="https://www.facebook.com/tr?id=${pixelId}&ev=PageView&noscript=1" />
        `;
        document.body.appendChild(noscript);
      }
    }
  }, [settings]);

  return null;
};

export default SeoManager;
